import React from "react";

import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { useClickHandler } from "hooks/notifications-hooks/use-click-handler";
import { IFeedItem } from "store/types";
import { formatNewsDate } from "utils/format-news-date";

function outputHTML(data?: string) {
  const sanitizedHtml = data?.replace(/<script.*?<\/script>/g, "");
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml || "" }} />;
}

interface PlatformUpdatesProps {
  data: IFeedItem;
}

export const PlatformUpdates: React.FC<PlatformUpdatesProps> = ({ data }) => {
  const notificationClickHandler = useClickHandler();

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      gap="12px"
      sx={{
        py: "12px",
        pr: "6px",
        borderBottom: "1px solid #E5E8EF",
        "&:last-child": { borderBottom: "none" },
        "&:hover .article-title": { color: "#26a6ae" }
      }}
    >
      <Stack direction="row" alignItems="flex-start" gap="10px" flex={1} minWidth={0}>
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "6px",
            backgroundColor: "#EBF3FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            mt: "2px"
          }}
        >
          <NotificationsNoneOutlinedIcon sx={{ fontSize: 15, color: "#2A7CDC" }} />
        </Box>
        <Stack minWidth={0} flex={1}>
          <Typography
            onClick={() => data.extraData && notificationClickHandler(data.extraData)}
            className="article-title"
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              color: "#252D39",
              lineHeight: 1.4,
              wordBreak: "break-word",
              cursor: data.extraData ? "pointer" : "default"
            }}
          >
            {outputHTML(data.title || data.body)}
          </Typography>
        </Stack>
      </Stack>
      <Typography
        sx={{
          fontSize: "12px",
          color: "#97A6BF",
          whiteSpace: "nowrap",
          flexShrink: 0,
          mt: "3px"
        }}
      >
        {formatNewsDate(data.extraData?.created_at || "")}
      </Typography>
    </Stack>
  );
};
